import React from 'react';

import errorIcon from '../../../../../assets/icons/error.svg';

import { Container, ImageWrapper, Img, Text } from './styles';

type ChipStatusProps = {
  item: {
    icon: string;
    text: string;
  };
  active?: boolean;
  selected?: boolean;
  itemId?: null | number;
  statusNumber?: number;
};

const ChipStatus: React.FC<ChipStatusProps> = ({
  item,
  active,
  selected,
  itemId,
  statusNumber,
}) => {
  const isSuccessful = itemId === 6 && statusNumber === 6;
  const isError = itemId === 6 && statusNumber === 6.1;

  const defaultMessage =
    itemId === 3 && statusNumber === 3.1 ? 'Reagendado' : item.text;
  const description = isError ? 'Não atendido' : defaultMessage;

  return (
    <Container active={active} selected={selected}>
      <ImageWrapper
        active={active}
        selected={selected}
        isSuccessful={isSuccessful}
        isError={isError}
      >
        <Img
          src={isError ? errorIcon : item.icon}
          alt={`status-${item.text}`}
        />
      </ImageWrapper>
      <Text active={active} selected={selected}>
        {description}
      </Text>
    </Container>
  );
};

ChipStatus.defaultProps = {
  active: false,
  selected: false,
  itemId: null,
  statusNumber: 0,
};

export default ChipStatus;
